import React, {CSSProperties, useState} from "react";
import {useDialog} from "../providers/DialogProvider";
import {useDispatch} from "react-redux";
import {ApplicationDispatch} from "../store/application/types";
import {addNewVehicle} from "../Data/VehicleData";
import VehicleAddNewDialog from "./VehicleAddNewDialog";
import {IconButton, Tooltip} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {getGeneratedStockNumberAsync} from "../utils/utils";
import {CreateVehicle} from "../Interfaces/Vehicle/CreateVehicle";

interface VehicleAddIconComponentProps {
  applicationId: string;
  vehicleOrganizationId: string;
  disabled?: boolean;
  style?: CSSProperties;
}

export default function VehicleAddIconComponent(props: VehicleAddIconComponentProps) {
  const [openDialog, closeDialog] = useDialog();
  const dispatch = useDispatch<ApplicationDispatch>();

  const addVehicle = async(vehicleToAdd: CreateVehicle, applicationId: string) => {
    const vehicleAddInfo = {vehicle: vehicleToAdd, applicationId};
    //const isApplicationVehicle = props.vehicleOnApp?.id === vehicleId;
    const addVehicleResult = await addNewVehicle(dispatch, vehicleAddInfo);
    return addVehicleResult.wasSuccessful;
  }
  
  return (
    <Tooltip title="Create New Vehicle" placement="top">
      <IconButton
        size="small"
        disabled={props.disabled}
        onClick={async () => {
          const stockNumber = await getGeneratedStockNumberAsync();
          
          openDialog({
            children: (
              <VehicleAddNewDialog
                onClose={closeDialog}
                onSaveVehicle={async(vehicleToAdd: CreateVehicle) => {
                  const wasSuccessful = await addVehicle(vehicleToAdd, props.applicationId);
                  if(wasSuccessful){
                    closeDialog();
                  }
                }}
                vehicleOrganizationId={props.vehicleOrganizationId}
                generatedStockNumber={stockNumber}
              />
            )
          });
        }}
      >
        <>
          {/* <DirectionsCarIcon style={{position: 'absolute'}} fontSize="small" /> */}
          <AddIcon fontSize="small" style={{padding: '0px'}} />
        </>
      </IconButton>
    </Tooltip>
  )
}